import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=5af952eb"
import script from "./SearchFilters.vue?vue&type=script&lang=js"
export * from "./SearchFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports